import { takeEvery } from "redux-saga/effects";
import {
  checkUserReviewAction,
  getAllReviewsInstructorAction,
  getAllReviewsUserAction,
  getCourseReviewsAction,
  getCourseReviewSummaryAction,
  getInstructorReviewSummaryAction,
  getMoreCourseReviewsAction,
  getMoreReviewsInstructorAction,
  getMoreReviewsUserAction,
  getTotalReviewInstructorAction,
  getTotalReviewUserAction,
  submitReviewCourseAction,
  updateReviewCourseAction,
} from "./slices";
import {
  submitReviewCourseWorker,
  getCourseReviewsWorker,
  getAllReviewsUserWorker,
  getMoreCourseReviewsWorker,
  updateReviewCourseWorker,
  checkUserReviewWorker,
  getCourseReviewSummaryWorker,
  getTotalReviewUserWorker,
  getAllReviewsInstructorWorker,
  getMoreReviewsInstructorWorker,
  getTotalReviewInstructorWorker,
  getMoreReviewsUserWorker,
  getInstructorReviewSummaryWorker,
} from "./workers";

const reviewWatcher = [
  takeEvery(getCourseReviewsAction, getCourseReviewsWorker),
  takeEvery(submitReviewCourseAction, submitReviewCourseWorker),
  takeEvery(getAllReviewsUserAction, getAllReviewsUserWorker),
  takeEvery(getMoreReviewsUserAction, getMoreReviewsUserWorker),
  takeEvery(getMoreCourseReviewsAction, getMoreCourseReviewsWorker),
  takeEvery(updateReviewCourseAction, updateReviewCourseWorker),
  takeEvery(checkUserReviewAction, checkUserReviewWorker),
  takeEvery(getCourseReviewSummaryAction, getCourseReviewSummaryWorker),
  takeEvery(getTotalReviewUserAction, getTotalReviewUserWorker),
  takeEvery(getAllReviewsInstructorAction, getAllReviewsInstructorWorker),
  takeEvery(getMoreReviewsInstructorAction, getMoreReviewsInstructorWorker),
  takeEvery(getTotalReviewInstructorAction, getTotalReviewInstructorWorker),
  takeEvery(getInstructorReviewSummaryAction, getInstructorReviewSummaryWorker),
];

export default reviewWatcher;
